import * as React from 'react';
import { RouteComponentProps, Link as RouterLink } from 'react-router-dom';
import { Editor, EditorTools, EditorUtils } from '@progress/kendo-react-editor';
import { fetchApi } from '../../services/api';
const DocumentTitle = require('react-document-title');

const { Bold, Italic, Underline,
    AlignLeft, AlignRight, AlignCenter,
    Indent, Outdent,
    OrderedList, UnorderedList,
    Undo, Redo, Link, Unlink } = EditorTools;

type Props = RouteComponentProps<{
    agreementId: string;
    agreementVersion: string;
}>

type State = {
    agreement: AgreementData;
    validation: boolean;
}

type AgreementData = {
    AgreementId: number;
    AgreementVersion: number;
    AgreementVersionLatest: number;
    Title: string;
    Body: string;
}

export default class Agreement extends React.Component<Props, State>{

    private editor: React.RefObject<Editor>;

    constructor(props: Props) {
        super(props);

        this.state = {
            agreement: {
                AgreementId: 0,
                AgreementVersion: 0,
                AgreementVersionLatest: 0,
                Title: '',
                Body: ''
            },
            validation: false,
        }

        this.editor = React.createRef();

        this.save = this.save.bind(this);
        this.updateAgreement = this.updateAgreement.bind(this);
    }

    public componentWillMount() {
        let agreementId = parseInt(this.props.match.params.agreementId) || 0;
        let agreementVersion = parseInt(this.props.match.params.agreementVersion) || 0;

        this.requestAgreement(agreementId, agreementVersion);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let agreementId = parseInt(nextProps.match.params.agreementId) || 0;
        let agreementVersion = parseInt(nextProps.match.params.agreementVersion) || 0;

        if (this.state.agreement && (this.state.agreement.AgreementId != agreementId || this.state.agreement.AgreementVersion != agreementVersion)) {
            this.requestAgreement(agreementId, agreementVersion);
        }
    }

    public render() {
        return <React.Fragment>
            <div className="k-form">
                <DocumentTitle title='Agreement' />
                <h3>Agreement</h3>
                {this.state.agreement.AgreementVersion != this.state.agreement.AgreementVersionLatest &&
                <div className="alert alert-warning" role="alert">
                    This is an outdated version of this agreement&nbsp;
                    <RouterLink className="alert-link" to={`/agreement/${this.state.agreement.AgreementId}/${this.state.agreement.AgreementVersionLatest}`}>View Latest</RouterLink>
                </div>}
                <span className="k-form-field">
                    <input
                        className="form-control input-group wide"
                        type="text"
                        name="Title"
                        placeholder="Title"
                        value={this.state.agreement.Title}
                        onChange={(e) => this.updateAgreement({ Title: e.target.value })}
                    />
                </span>
                <Editor
                    className="bg-light"
                    ref={this.editor}
                    tools={[
                        [ Bold, Italic, Underline ],
                        [ Undo, Redo ],
                        [ Link, Unlink ],
                        [ AlignLeft, AlignCenter, AlignRight ],
                        [ OrderedList, UnorderedList, Indent, Outdent ]
                    ]}
                    contentStyle={{ height: 320 }}
                />
                {this.state.agreement.AgreementVersion === this.state.agreement.AgreementVersionLatest && <button onClick={this.save} className="btn btn-primary">Update Agreement</button>}
            </div>
        </React.Fragment>
    }

    private requestAgreement(agreementId: number, agreementVersion: number) {
        fetchApi(`api/Agreement/Get/${agreementId}/${agreementVersion}`)
            .then((agreement: AgreementData) => {
                const editorRef = this.editor;
                const view = editorRef.current.view;
                EditorUtils.setHtml(view, agreement.Body);
                this.setState({ agreement });
            });
    }

    private updateAgreement(value: Partial<AgreementData>) {
        const agreement = Object.assign({}, this.state.agreement, value);
        this.setState({ agreement });
    }

    private save() {
        if (this.state.agreement && confirm(`Are you sure you want to update ${this.state.agreement.Title}?`)) {
            const view = this.editor.current.view;
            const data = {
                Title: this.state.agreement.Title,
                Body: EditorUtils.getHtml(view.state),
            }

            fetchApi(`api/Agreement/Save/${this.state.agreement.AgreementId}/${this.state.agreement.AgreementVersion}`, data, 'POST')
                .then(() => {
                    this.props.history.push("/agreements");
                })
        }
    }
}
